import Model from 'src/app/common/model';
import PondSectionModel from './pondSection.model';
import FeedMealModel from './feedMeal.model';
import CheckTrayReadingModel from './checkTaryReading.model';
import MealFeedTypeModel from './mealFeedType.model';
import CheckTrayFeedTypeModel from './checkTrayFeedType.model';
import ItemMasterModel from './itemMaster.model';
import FarmSiteModel from './farmSite.model';

export default class FeedLogModel extends Model {
  section_name: PondSectionModel;
  feedMeal: FeedMealModel;
  checkTray: CheckTrayReadingModel;
  MealFeedType: Array<MealFeedTypeModel>;
  CheckTrayFeedType: CheckTrayFeedTypeModel;
  ItemMaster: ItemMasterModel; // MMS
  FarmSiteDetails: FarmSiteModel; // TC
  FarmSummary: FarmSummaryDetails;
  itemUom?: Array<ItemUOM>;
  mixUom?: Array<MixUOM>;
  cultureDetailsUpdateStatus: CultureDetailsUpdateDencity;
  person_id?: string;
  farm_site_id: string;
  pond_id: number;
  busienss_id?: string;
  pond_culture_id: number;
  stocking_count?: number;
  present_no_of_animals?: number;
  isManualUOM?: boolean;
  culture_category_id?: number;
  feeditem_name?: string;
  name?: string;
  sampling_id?: number;
  feedrate_id?: number;
  blind_feed_calendar_id?: number;
  present_biomass: number;
  general_biomass: number;
  survival_rate: number;
  survival_count: number;
  doc: number;
  Date: string;
  pondName: string;
  DOC: number;
  feedGiven: any;
  last_feed_given_date: Date;
  feed_given: number;
  feed_required: number;
  cumulative_feed: number;
  feed_consumed: number;
  from_units_uom_id: number;
  from_value: number;
  to_units_uom_id: number;
  to_value: number;
  recommendation: Text;
  pondsCount: number;
  count: object;
  createddate: string;
  createdAttime: string;
  meal_consumed: number;
  meal_given: number;
  given_time?: string;
  check_tray_feed_given?: number;
  imagecount: number;
  abw: number;
  survivalRate: number;
  totalBiomass: number;
  totalHarvestCount: number;
  totalConsumption: number;
  harvestedBiomass: number;
  FCR: number;
  noofsections: number;
  noofponds: number;
  date: string | Date;
  time: Date;
  pondIds: Array<string>;
  start_date?: Date;
  mixitem_name?: string;
  mixuomname?: string;
  adgValue?: number;
  cultureLatestDate: string;
  daysFeed: number;
  daysFeedDate: string;
  numberOfAnimals: number;
  presentBiomass: number;
  presentBiomassDate: string;
  samplingDate: string;
  survivalRateDate: string;
  totalConsumptionDate: string;
  weightGained: number;
  shift_date: string;
  source_tank_id: string;
  destination_tank_id: string;
  shifted_animals: number;
  shiftType: string;
  source_section_id: number | string;
  destination_section_id: number | string;
  sourceDencity: number;
  sourceCumulativeFeed: number;
  destinationDencity: number;
  destinationCumulativeFeed: number;
  adg: number;
  ABW: boolean;
  ADG: boolean;
  tbm: boolean;
  sr: boolean;
  fcr: boolean;
  dcf: boolean;
  all: boolean;
  pondCultureData: any;
  total_biomass: number;
  location_tracker_id: string;

 constructor() {
    super();
    this.itemUom = new Array();
    this.mixUom = new Array();
  }
}

//////////////////////////////
//ItemUOM
//////////////////////////////
export class ItemUOM {
  id?: number;
  name?: string;
  uomadded?: boolean;

  constructor() { }
}

//////////////////////////////
//FarmSummaryDetails
//////////////////////////////
export class FarmSummaryDetails {
  totalBiomass: string;
  totalConsumption: string;
  survivalRate: string;

  constructor() { }
}

//////////////////////////////
//CultureDetailsUpdateDencity
//////////////////////////////
export class CultureDetailsUpdateDencity {
  destinationDencity: number;
  message: string;
  sourceDencity: number;

  constructor() { }
}

//////////////////////////////
//MixUOM
//////////////////////////////
export class MixUOM {
  id?: number;
  name?: string;
  uomadded?: boolean;

  constructor() { }
}

